import React from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container component="main" maxWidth="lg">
      <SEO
        title="RobertGarza.us Family Court Reform - Page Not Found"
        description="The page you are looking for could not be found."
        path="/404"
        noindex={true}
        noCanonical={true}
      />
      <Box
        sx={{
          minHeight: '70vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: { xs: 4, md: 8 },
        }}
      >
        <Typography variant="h1" sx={{ fontWeight: 800, mb: 2 }}>
          404
        </Typography>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Page Not Found
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          The page you are looking for doesn't exist or has been moved.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <Button variant="contained" size="large" onClick={() => navigate('/')}>
            Go to Homepage
          </Button>
          <Button variant="outlined" size="large" onClick={() => navigate('/family-court-reform-bills')}>
            Browse Bills
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default NotFound;
